/**
 * Стандартные сообщения о статусах и ошибках
 */

const messages = {
  serverTimeout: 'Сервер недоступен. Пожалуйста, попробуйте позже',
  fileIncorrect: 'Неверный тип файла',
  fileNotfound: 'Фаил не найден',
  fileIsEmpty: 'Выберете фаил перед загрузкой',
  unknownError:
    'Произошла внутренняя ошибка сервиса. Обратитесь к администратору',
  passwordMismatch: 'Пароли не совпадают',
  passwordToShort: 'Минимальная длина пароля - 6 символов',
  inputCharsOnly: 'Допускаются только буквы',
  inputNumbersOnly: 'Допускаются только цифры',
  inputPhone: 'Некорректный номер телефона',
  inputEmail: 'Некорректный адрес почты',
  checkArgeeWithPolicy:
    'Для регистрации вы должны быть согласны с политикой обработки персональных данных',
  noStudents: 'Дабавьте хотябы одного участника',
  formError: 'Пожалуйста, проверьте правильность заполнения формы'
};

export default messages;
